<template>
  <div class="shareIndex">
    <!-- <img class="shareIndex-img" src="../../static/images/shouye_bg.png" alt />
    <div class="common-bg shareindex-btn shareindex-btn2" @click="tohome">参与抽奖，赢200分钟境外通话</div>-->
    <template v-if="channel && channel == 'changping'">
      <div class="shareIndex-top"></div>
      <!-- <img
      v-if="channel && channel == 'hbgj' && !isapp"
      class="ditch-logo"
      src="../../static/images/ditch_in_hbgj.png"
      alt
      />-->
       <div class="shareIndex-content flex-row">
        <img src="../../static/images/shouyecontent_bg.png" alt />
      </div>
    </template>
    <template v-else>
      <div class="shareIndex-top"></div>
      <!-- <img
      v-if="channel && channel == 'hbgj' && !isapp"
      class="ditch-logo"
      src="../../static/images/ditch_in_hbgj.png"
      alt
      />-->
      <div class="shareIndex-content flex-row">
        <img src="../../static/images/shouyecontent_bg.png" alt />
      </div>
    </template>

    <div class="shareindex-bottom">
      <div class="common-bg shareindex-btn shareindex-btn2" @click="tohome">参与抽奖</div>
      <div class="shareindex-bottom-img-wrap">
        <img class="shareindex-bottom-img" src="../../static/images/shareindex_bot.png" alt />
        <img class="shareindex-bottom-img" src="../../static/images/shareindex_bot02.png" alt />
      </div>
    </div>

    <input type="hidden" id="hello" value style="display:none;" />
    <div
      v-if="_getBrowser()==0"
      class="copy-btn btn-clipboard"
      id="btnH5"
      @click="_downloadAPP(1)"
      style="height:100vh;width:100vw;position:fixed;left:0;top:0;opacity:0;z-index:1000"
      data-clipboard-target="#hello"
    >下载app</div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  name: "shareindex",
  data() {
    return {
      urlData: null,
      channel: "0",
      isapp: false
    };
  },
  methods: {
    tohome() {
      var t = this;
      t.$router.push({
        path: "/home",
        query: {}
      });
      t._deepmain("h5open1", "yycj#h5open1#clickbutton", 2);
    },
    keyUrl() {
      var items = [];
      var url = location.href;
      if (url === undefined || typeof url != "string") {
        return null;
      }
      var json = {};
      var newurl = url.split("#")[0];
      var arr = newurl.split("?");
      if (arr.length > 1) {
        items = arr[1].split("&");
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i].split("=");
          json[item[0]] = item[1];
        }
      }
      return json;
    }
  },
  components: {},
  created() {
    var t = this;
    console.log(
      "jegotrip://deeplink?json=" +
        encodeURIComponent(
          JSON.stringify({
            type: "h5Nav",
            title: "【语音大奖 任意抽】",
            describe: " 抽奖活动：无忧行语音大奖任意抽",
            url:
              "https://cp.jegotrip.com.cn/partners/yycj_dist/index.html?jtpnav=1&islogin=1&isother=1#/",
            param: ""
          })
        )
    );
    console.log("userAgent:window load-----------");
    console.log(window.location.href);
    console.log(window.navigator.userAgent);
    t.urlData = t.keyUrl();
    var q = t.$route.query;
    if (q && Object.keys(q).length > 0) {
      t.urlData = q;
    }
    if (t.urlData.clear == 1) {
      localStorage.removeItem(config.login_key);
      window.location.reload();
    }
    console.log("t.urlData");
    console.log(t.urlData);
    // 入口页的参数看看是否有渠道参数channel
    if (t.urlData.channel) {
      t.channel = t.urlData.channel;
    }

    // 更新channel缓存:目的是用户点第一次有渠道显示logo，第二次进来没渠道不显示logo的情况处理
    var app_params_cache = localStorage.getItem(config.app_params_key);
    if (app_params_cache && app_params_cache.length > 0) {
      var app_params = JSON.parse(app_params_cache);
      app_params.channel = t.channel;
      localStorage.setItem(config.app_params_key, JSON.stringify(app_params));
    }
    console.log("t.channel", t.channel);

    var userAgent = window.navigator.userAgent.toLowerCase();
    t.isapp = userAgent.match(/jegotrip/i) == "jegotrip";

    t._deepmain("h5open1", "yycj#h5open1", 0);
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/shareindex.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
.shareindex-btn2 {
  animation: mymove 1s infinite;
  -webkit-animation: mymove 1s infinite;
}
@keyframes mymove {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@-webkit-keyframes mymove {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->